(function (root, factory) {
  var api = factory();

  if (typeof module === 'object' && module.exports) {
    module.exports = api;
    return;
  }

  root.DecoGardenFormsTeaserOffset = api;

  if (root.document && !root.__dgFormsTeaserOffsetLoaded) {
    root.__dgFormsTeaserOffsetLoaded = true;
    api.init(root, root.document);
  }
})(typeof globalThis !== 'undefined' ? globalThis : this, function () {
  'use strict';

  /* Shopify's cookie banner and the Shopify Forms "10% הנחה" teaser share the bottom of the
     screen, and on phones the banner covered the teaser. While the banner is up and the form is
     still a teaser, lift the teaser above the banner and the floaters stacked on it. Forms sizes
     its open popup with the same padding variable, so every other step keeps Forms' own value. */
  var PADDING_VAR = '--app-embed-padding-y';
  var GAP = 8;
  var BANNER_ID = 'shopify-pc__banner';
  var STACKED_FLOATERS = ['#mic-access-tool-general-button', 'a.wsp-whatsapp'];

  function intersects(a, b) {
    return a.left < b.right && b.left < a.right && a.top < b.bottom && b.top < a.bottom;
  }

  function computeLift(viewportHeight, teaser, banner, floaters, gap) {
    if (!teaser || !banner || !intersects(teaser, banner)) return null;

    var spacing = typeof gap === 'number' ? gap : GAP;
    var height = teaser.bottom - teaser.top;
    var obstacles = [banner].concat(floaters || []);
    var bottom = teaser.bottom;
    var moved = true;

    for (var pass = 0; moved && pass <= obstacles.length; pass += 1) {
      moved = false;
      var box = { left: teaser.left, right: teaser.right, top: bottom - height, bottom: bottom };
      for (var index = 0; index < obstacles.length; index += 1) {
        if (intersects(box, obstacles[index])) {
          bottom = obstacles[index].top - spacing;
          moved = true;
          break;
        }
      }
    }

    if (bottom - height < spacing) return null;
    return Math.ceil(viewportHeight - bottom);
  }

  function rectOf(element) {
    var rect = element.getBoundingClientRect();
    return { left: rect.left, right: rect.right, top: rect.top, bottom: rect.bottom };
  }

  function isShown(win, element) {
    if (!element) return false;
    var style = win.getComputedStyle(element);
    if (style.display === 'none' || style.visibility === 'hidden') return false;
    var rect = element.getBoundingClientRect();
    return rect.width > 0 && rect.height > 0 && rect.bottom > 0 && rect.top < win.innerHeight;
  }

  function teaserRect(win, formRoot) {
    // The form root is a click-through box pinned to the bottom edge, and the teaser fills its
    // content box. Its first child is a <style>, so measure the root itself.
    var rect = formRoot.getBoundingClientRect();
    var style = win.getComputedStyle(formRoot);
    return {
      left: rect.left + (parseFloat(style.paddingLeft) || 0),
      right: rect.right - (parseFloat(style.paddingRight) || 0),
      top: rect.top + (parseFloat(style.paddingTop) || 0),
      bottom: rect.bottom - (parseFloat(style.paddingBottom) || 0),
    };
  }

  function liftFor(win, doc, host) {
    var formRoot = host.shadowRoot && host.shadowRoot.querySelector('[data-form-root]');
    if (!formRoot || formRoot.getAttribute('data-current-step') !== 'tease') return null;

    var banner = doc.getElementById(BANNER_ID);
    if (!isShown(win, banner)) return null;

    var teaser = teaserRect(win, formRoot);
    if (teaser.bottom <= teaser.top) return null;

    var floaters = STACKED_FLOATERS.map(function (selector) {
      return doc.querySelector(selector);
    })
      .filter(function (element) {
        return isShown(win, element);
      })
      .map(rectOf);

    return computeLift(win.innerHeight, teaser, rectOf(banner), floaters, GAP);
  }

  function update(win, doc) {
    Array.prototype.forEach.call(doc.querySelectorAll('shopify-forms-embed'), function (host) {
      // Measure the teaser where Forms rests it, not where an earlier lift put it. Nothing paints
      // between clearing the lift and setting it again.
      if (host.style.getPropertyValue(PADDING_VAR)) host.style.removeProperty(PADDING_VAR);
      var lift = liftFor(win, doc, host);
      if (lift !== null) host.style.setProperty(PADDING_VAR, lift + 'px');
    });
  }

  function init(win, doc) {
    var Observer = win.MutationObserver;
    var watchedShadows = [];
    var watchedBanner = null;
    var scheduled = false;

    function watch() {
      Array.prototype.forEach.call(doc.querySelectorAll('shopify-forms-embed'), function (host) {
        var shadow = host.shadowRoot;
        if (!shadow || !Observer || watchedShadows.indexOf(shadow) !== -1) return;
        watchedShadows.push(shadow);
        new Observer(schedule).observe(shadow, {
          childList: true,
          subtree: true,
          attributes: true,
          attributeFilter: ['data-current-step'],
        });
      });

      var banner = doc.getElementById(BANNER_ID);
      if (!banner || banner === watchedBanner) return;
      watchedBanner = banner;
      if (Observer) {
        new Observer(schedule).observe(banner, {
          attributes: true,
          attributeFilter: ['class', 'style', 'hidden', 'aria-hidden'],
        });
      }
      if (typeof win.ResizeObserver === 'function') new win.ResizeObserver(schedule).observe(banner);
      // A slide-in moves the banner without resizing it; measure again once it settles.
      banner.addEventListener('transitionend', schedule);
      banner.addEventListener('animationend', schedule);
    }

    function schedule() {
      if (scheduled) return;
      scheduled = true;
      var frame = win.requestAnimationFrame
        ? win.requestAnimationFrame.bind(win)
        : function (callback) {
            return win.setTimeout(callback, 16);
          };
      frame(function () {
        scheduled = false;
        watch();
        update(win, doc);
      });
    }

    if (Observer && doc.body) new Observer(schedule).observe(doc.body, { childList: true });
    win.addEventListener('resize', schedule);
    win.addEventListener('load', schedule);
    schedule();
  }

  return {
    computeLift: computeLift,
    update: update,
    init: init,
  };
});
